import React from 'react'

import Mentions from '../components/Mentions'

const legal = () => {
  return <Mentions />
}

export default legal
